/* src/app/modules/employees/asuntos-propios/asuntos-propios.component.css */
:host {
  --ap-brand: #e3fd64;
  --ap-brand-d: #4d7a00;
  --ap-text: #1a1d23;
  --ap-muted: #6b7280;
  --ap-border: #e5e7eb;
  --ap-surface: #ffffff;
  --ap-radius: 10px;
  --ap-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.ap-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ap-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ap-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ap-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.ap-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.ap-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--ap-text);
  line-height: 1.2;
}
.ap-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--ap-muted);
}
.ap-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ap-btn-primary {
  background-color: var(--ap-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ap-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ap-muted) !important;
}
.ap-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.ap-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.ap-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--ap-brand);
}
.ap-loading__dots {
  display: flex;
  gap: 8px;
}
.ap-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ap-brand);
  opacity: 0.3;
  animation: ap-pulse 1.2s ease-in-out infinite;
}
.ap-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.ap-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.ap-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--ap-muted);
}
@keyframes ap-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.ap-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ap-section__head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.ap-pill {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}
.ap-pill--pending {
  background: #f59e0b;
}
.ap-pill--approved {
  background: #16a34a;
}
.ap-pill--search {
  background: #3b82f6;
}
.ap-section__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ap-text);
  line-height: 1.3;
}
.ap-section__sub {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--ap-muted);
}
.ap-card {
  background: var(--ap-surface);
  border-radius: var(--ap-radius);
  box-shadow: var(--ap-shadow);
  border: 1px solid var(--ap-border);
  overflow: hidden;
}
.ap-table {
  width: 100%;
}
.ap-table th.mat-mdc-header-cell {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--ap-muted);
  background: #f9fafb;
  border-bottom: 1px solid var(--ap-border);
  padding: 12px 16px;
}
.ap-table td.mat-mdc-cell {
  padding: 14px 16px;
  font-size: 13.5px;
  color: var(--ap-text);
  border-bottom: 1px solid var(--ap-border);
  vertical-align: middle;
}
.ap-row:last-child td.mat-mdc-cell {
  border-bottom: none;
}
.ap-row:hover td.mat-mdc-cell {
  background: #fafafa;
}
.ap-cell-employee {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ap-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--ap-brand-d);
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
}
.ap-date {
  font-size: 13px;
  color: var(--ap-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ap-estado-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  background: rgba(227, 253, 100, 0.1);
  color: #a07500;
}
.ap-estado-badge--ok {
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}
.ap-estado-badge--warn {
  background: rgba(245, 158, 11, 0.1);
  color: #92400e;
}
.ap-col-actions {
  width: 52px;
  text-align: right !important;
  padding-right: 12px !important;
}
.ap-menu-trigger {
  opacity: 0;
  transition: opacity 0.15s;
}
.ap-row:hover .ap-menu-trigger {
  opacity: 1;
}
.ap-filter-card {
  background: var(--ap-surface);
  border: 1px solid var(--ap-border);
  border-radius: var(--ap-radius);
  box-shadow: var(--ap-shadow);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ap-filter-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ap-text);
}
.ap-filter-card__icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--ap-brand);
}
.ap-filter-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.ap-filter-field {
  flex: 1;
  min-width: 220px;
}
.ap-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
  flex-shrink: 0;
}
.ap-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 24px;
  text-align: center;
  background: var(--ap-surface);
  border: 1px solid var(--ap-border);
  border-radius: var(--ap-radius);
}
.ap-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.1);
}
.ap-empty__art mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--ap-brand);
}
.ap-empty__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ap-text);
}
.ap-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--ap-muted);
  max-width: 320px;
}
.ap-action-danger,
.ap-action-danger mat-icon {
  color: #dc2626 !important;
}
.ap-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
/*# sourceMappingURL=asuntos-propios.component.css.map */
